module.exports = __webpack_public_path__ + "static/media/notification.423c745f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notification.svg
// module id = 1418
// module chunks = 1